module.exports = __webpack_public_path__ + "img/art-60.cdb07762.png";